import { apiGet, apiPost, apiPut } from '@/api/client';
import type {
  Communication,
  CommunicationAudience,
  CommunicationCategory,
  CommunicationStatus,
} from '@/api/types';

export function listCommunications(companyId: string): Promise<Communication[]> {
  return apiGet('/companies/{companyId}/communications', {
    params: { companyId },
  }) as unknown as Promise<Communication[]>;
}

export interface NewCommunicationInput {
  title: string;
  message: string;
  category: CommunicationCategory;
  target_audience: CommunicationAudience;
  scheduled_at?: string | null;
  call_to_action?: string | null;
  quiet_hours?: boolean;
  status?: CommunicationStatus;
}

export function createCommunication(
  companyId: string,
  input: NewCommunicationInput,
): Promise<{ communication_id: string }> {
  return apiPost('/companies/{companyId}/communications', {
    params: { companyId },
    body: input,
  }) as unknown as Promise<{ communication_id: string }>;
}

/** Changes a communication's status (concept -> ingepland -> verzonden). */
export function setCommunicationStatus(
  companyId: string,
  communicationId: string,
  status: CommunicationStatus,
): Promise<{ communication_id: string; status: CommunicationStatus }> {
  return apiPut('/companies/{companyId}/communications/{communicationId}', {
    params: { companyId, communicationId },
    body: { status },
  }) as unknown as Promise<{ communication_id: string; status: CommunicationStatus }>;
}
